import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const purchaseOrderListStyle = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: "#f8f8f8"
    },
    badgeStyle: {
        borderRadius: 8,
        marginLeft: 10
    },
    badgeTitle: {
        fontFamily: appFonts.bold, fontSize: fontSize.badgeFontSize, paddingHorizontal: 10, textAlign: 'center'
    },
    iconStyle: {
        color: appColors.grey,
        paddingRight: 5
    },
    plusIconView: {
        alignSelf: "flex-end",
        backgroundColor: appColors.primary,
        borderRadius: 50,
        alignItems: "center",
        justifyContent: "center",
        height: 55,
        width: 55,
        position: "absolute",
        bottom: 25,
        right: 25
    },
    popoverStyle: {
        borderRadius: 10
    },
    buttonView: {
        flexDirection: "row",
        alignItems: "center"
    },
    filterView: {
        borderWidth: 0,
        marginHorizontal: 10,
        marginRight: 15,
        marginTop: 10
    },
    badgeContainerStyle: {
        position: "absolute",
        left: 15,
        top: -8,
        paddingHorizontal: 7
    },
    badgeTextStyle: {
        fontFamily: appFonts?.medium,
        fontSize: fontSize?.badgeFontSize
    },
    buttonStyle: {
        borderRadius: 10, backgroundColor: appColors?.primary, marginTop: 10, padding: 1
    },
    label: {
        fontSize: fontSize.smallFontSize,
        color: appColors.labelColor,
        fontFamily: appFonts.medium,
    },
    value: {
        fontSize: fontSize.smallFontSize,
        color: appColors.lightDark,
        fontFamily: appFonts.bold,
    },
    iconBox: {
        padding: 10,
        backgroundColor: appColors.lightBackgroundColor,
        borderRadius: 10,
        marginLeft: 10,
    },
})
